module.exports = __webpack_public_path__ + "static/media/maven.5a40ba81.png";